import { PropsWithChildren } from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

const variants = cva("flex justify-center mx-auto rounded-[22px]",
    {
        variants: {
            direction: {
                col: "flex-col",
                row: "flex-row"
            },
            theme: {
                dark: "bg-linear-gradient text-white",
                light: "text-grey bg-grey-200 border border-stroke",
            },
            gap: {
                default: "gap-[44px]",
                30: "gap-[30px]",

            },
            padding: {
                default: "py-[40px] md:py-[70px] px-[22px] md:px-[78px]",
                "50/40": "py-[40px] md:py-[50px] px-[22px] md:px-[40px]",
                //sm: "gap-[23px] md:gap-[70px]"
                // sm: "h-8 rounded-md px-3 text-xs",
                // lg: "h-10 rounded-md px-8",
                // icon: "h-9 w-9",
            },
        },
        defaultVariants: {
            theme: "dark",
            gap: "default",
            padding: "default",
            direction: "col"
        },
    }
)

type Props = PropsWithChildren<{
    className?: string,
    onClick?: any
} & VariantProps<typeof variants>>;

const Card = ({children, padding, className, theme, onClick}: Props) => {
    return (
        <div className={cn(variants({padding, theme}), className)} onClick={onClick}>
            {children}
        </div>
    );

}

export default Card;